/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { Modal, Search, MyButton, Pagination } from "../../component/Component";
import { pushOneRegionalBlocks } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useRegionalBlocksContext } from "../../../../context/regionalBlocks/RegionalBlocksContext";
import { FiPlus, FiEdit2, FiTrash2, FiLayers } from "react-icons/fi";

const addRoute = "/regional/blocks/add";
const editRoute = "/regional/blocks/edit";

const Overview = () => {
  const [regionalBlocksList, setRegionalBlocksList] = useState([]);
  const { regionalBlocks, fetchRegionalBlocks, count } =
    useRegionalBlocksContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!regionalBlocks) fetchRegionalBlocks(page, pageSize);
    setRegionalBlocksList(regionalBlocks);
  }, [regionalBlocks]);

  const SearchList = (e) => {
    const key = String(e.target.value).toLowerCase();
    let searchArray = [];
    if (regionalBlocks) {
      regionalBlocks.map((rBlocks) => {
        if (rBlocks?.name.toString().toLowerCase().includes(key))
          return searchArray.push(rBlocks);
        return true;
      });
    }
    setRegionalBlocksList(searchArray);
    if (key === "") setRegionalBlocksList(regionalBlocks);
  };

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4">
      <div className="mx-auto max-w-7xl">
        <div className="relative mb-4 rounded-3xl border border-gray-200 bg-white/90 p-4 shadow-sm backdrop-blur">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <FiLayers className="h-5 w-5" />
              </span>
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Regional Blocks
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Manage regional economic and political blocks.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <span className="rounded-full bg-gray-100 px-3 py-1 text-[11px] font-semibold text-gray-700">
                {Number(count || 0).toLocaleString()} total
              </span>
              <Link to={addRoute}>
                <div className="inline-flex items-center gap-2">
                  <FiPlus className="h-4 w-4 text-gray-700" />
                  <MyButton
                    title="Add Regional Block"
                    className="bg-gray-900 hover:bg-black"
                    onClick={() => { }}
                  />
                </div>
              </Link>
            </div>
          </div>

          <div className="mt-3">
            <Search
              props={{
                title: "Regional Block",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
        </div>

        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="relative max-h-[60vh] overflow-auto">
            <table className="min-w-full table-fixed text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                  <th className="w-1/2 px-4 py-3 font-semibold">Name</th>
                  <th className="w-1/2 px-4 py-3 text-center font-semibold">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {regionalBlocksList ? (
                  regionalBlocksList?.map((rBlocks, key) => (
                    <tr
                      key={key}
                      className="group border-t border-gray-100 hover:bg-gray-50/60"
                    >
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center gap-3">
                          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-[11px] font-bold text-white shadow-sm">
                            {(rBlocks?.name || "RB").slice(0, 2).toUpperCase()}
                          </span>
                          <span className="truncate font-semibold text-gray-900">
                            {rBlocks?.name}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center justify-center gap-3">
                          <ActionButton props={rBlocks} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="border-t border-gray-100">
                    <td className="px-4 py-6 text-center text-gray-500" colSpan={2}>
                      Loading…
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="border-t border-gray-100 px-4 py-3">
            <div className="flex items-center justify-end">
              <Pagination
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total_items={count}
                callbackFunction={(_page_, _pageSize_) => {
                  fetchRegionalBlocks(_page_, _pageSize_);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ props }) => {
  const { regionalBlocks, updateRegionalBlocksState, deleteRegionalBlocks } =
    useRegionalBlocksContext();

  const [showModal, setShowModal] = useState(false);

  const trade_organization_id = props.trade_organization_id;
  const regionalBlocks_name = props.name;
  const _regionalBlocks_ = props;

  const deleteOneRegionalBlocksById = async (trade_organization_id) => {
    const { status } = await deleteRegionalBlocks(trade_organization_id);
    if (status === 200) {
      if (regionalBlocks) {
        const update = regionalBlocks.filter(
          (_regionalBlocks_) =>
            _regionalBlocks_.trade_organization_id !== trade_organization_id
        );
        updateRegionalBlocksState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: regionalBlocks_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneRegionalBlocksById(trade_organization_id),
        }}
      />

      <div className="flex items-center gap-3">
        <Link to={editRoute}>
          <div className="inline-flex items-center gap-2">
            <FiEdit2 className="h-4 w-4 text-blue-700" />
            <MyButton
              title="Edit"
              className="py-3 px-8 bg-blue-700 hover:bg-blue-600"
              onClick={() => pushOneRegionalBlocks(_regionalBlocks_)}
            />
          </div>
        </Link>

        <div className="inline-flex items-center gap-2">
          <FiTrash2 className="h-4 w-4 text-red-700" />
          <MyButton
            title="Delete"
            className="py-3 px-8 bg-red-700 hover:bg-red-600"
            onClick={() => setShowModal(true)}
          />
        </div>
      </div>
    </>
  );
};

export default Overview;
